import * as types from '../actions/links/types';

const INITIAL_STATE = {
  links: []
};

export default function linksReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case types.GET_LINKS:
      return { ...state, links: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/linksReducer.js